import React from 'react';
import { connect } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import Lbl from '../../../inputs/label.js';
import objectAssign from 'object-assign';
import { updateMeetingRoomForm } from '../../../../actions/meetingRoom.js';

@connect()
export default class CenterPanelView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: props.groups,
      meetingRoomForm: props.meetingRoomForm,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
    this.setState({
      groups: props.groups,
      meetingRoomForm: props.meetingRoomForm,
    });
    this.props = props;
  }
  render() {
    let orgName = this.state.meetingRoomForm.organisationAbbreviatedName;
    return (
      <div className="ui form">
        <div className="field ">
          <div className="max-width mrbm pdts">
            <span className="bold">{APP.LANGUAGE.ViewSingleMeetingRoom.GroupLabel} :</span> {orgName}{' '}
          </div>
        </div>
      </div>
    );
  }
}
